(() => {
  const SELLER_NAMES = [
    "Platinum Vault", "CardHorde", "Mint Condition TCG", "Spellbound Cards",
    "The Card Hub", "Nerd Rage Gaming", "ShuffleUp", "Rare Finds TCG", "Overdose Gaming",
    "Strike Zone Cards", "CoolStuffInc", "Channel Fireball", "Troll and Toad", "Card Kingdom",
    "Fusion Gaming", "Face to Face Games", "Pastimes", "Card Titan", "MTG Deals",
    "YGO Empire", "PokeVault", "Lorcana Loft", "One Piece Port", "Dragon Shield Shop",
    "Black Lotus Den", "Exodia Store", "Starlight Rare", "Holo Haven", "Booster Box Bros",
    "The Binder Guy", "Pull Rate Pro", "Sleeve City", "Deckbox Depot", "Graveyard Games",
    "Main Phase 2", "Normal Summon", "Set Rotation", "Unlimited Edition", "First Edition Finds",
    "Alpha Cards", "Arcane Exchange", "Binder Alley", "Blue Eyes Bazaar", "Champion Cartel",
    "Dark Duel Depot", "Eternal Emporium", "Foil Forge", "Galaxy Guild", "Hero Haven",
    "Ink & Sleeves", "Jester's Vault", "Kuriboh Cart", "Legend Locker", "Mana Market",
    "Nexus Cards", "Obelisk Outlet", "Pendulum Pit", "Quest Quarters", "Raid Ready",
    "Synchro Supply", "Tribute Table", "Ultra Rare Hut", "Vanguard Vault", "Wishing Well TCG",
    "XYZ Shop", "Yellow Archive", "Zeus Zone", "Ash Blossom Co", "Blue-Eyes Booth",
    "Chaos Shop", "Direct Deals TCG", "Extra Deck Express", "Forbidden Cards", "Gold Rare Goods",
    "Cardboard Junky",
  ];
  const SELLER_CITIES = [
    "North York, ON, Canada", "Los Angeles, CA, United States", "Dallas, TX, United States",
    "Seattle, WA, United States", "Toronto, ON, Canada", "Orlando, FL, United States",
    "Chicago, IL, United States", "Montreal, QC, Canada", "Austin, TX, United States",
    "Columbus, OH, United States",
  ];
  const CONDITIONS = ["Near Mint", "Lightly Played", "Moderately Played", "Heavily Played"];
  const SHIPPING = 5.99;
  const COMMENTS = [
    "Cards arrived quickly and were well protected. Would buy again.",
    "Exactly as described. Great communication.",
    "Fast shipping. Product was mint.",
    "Smooth transaction. Packaged with care.",
    "Item matched the listing. Highly recommended.",
    "Shipped the same day. Perfect condition.",
    "Good prices and a reliable seller.",
    "One of my go-to shops on TCGplayer.",
  ];

  const cfg = window.TCGSellers || {};
  const root = (cfg.root || "/").replace(/\/?$/, "/");
  const currency = cfg.currency || window.Shopify?.currency?.active || "USD";

  function hashSeed(str) {
    let h = 2166136261;
    for (const c of String(str)) h = Math.imul(h ^ c.charCodeAt(0), 16777619);
    return h >>> 0;
  }

  const PROFILE_OVERRIDES = {
    "Cardboard Junky": { city: "North York, ON, Canada", rating: 100, sales: 4478, years: 4, certified: true, reviews: 4200 },
  };

  function sellerProfile(name) {
    const h = hashSeed(name);
    const rating = Math.min(100, +((98 + (h % 21) / 10).toFixed(1)));
    const reviews = 180 + (h % 62400);
    return Object.assign({
      name,
      rating,
      reviews,
      sales: reviews + (h % 9000),
      city: SELLER_CITIES[h % SELLER_CITIES.length],
      years: 1 + (h % 12),
      certified: rating >= 98.5,
    }, PROFILE_OVERRIDES[name] || {});
  }

  function findSeller(name) {
    let raw = String(name || "").replace(/\/$/, "");
    try { raw = decodeURIComponent(raw.replace(/\+/g, " ")); } catch (_) { /* keep */ }
    return sellerProfile(raw || "Marketplace Seller");
  }

  function salesLabel(n) {
    const v = Number(n) || 0;
    if (v >= 100000) return `${Math.floor(v / 1000)}k+`;
    if (v >= 10000) return `${Math.floor(v / 1000) * 1000}+`;
    return `${v.toLocaleString()}+`;
  }

  function sellerFeedback(s) {
    return `${Number(s.rating).toFixed(1)}% Feedback | ${salesLabel(s.sales)} Sales`;
  }

  function money(amount) {
    const n = Number(amount) || 0;
    return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(n);
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function sellerHref(name, params) {
    const qs = params && params.toString ? params.toString() : "";
    return `${root}?view=seller#/seller/${encodeURIComponent(name)}${qs ? "?" + qs : ""}`;
  }

  function iconCertStar() {
    return `<svg width="12" height="12" viewBox="0 0 24 24" fill="#fff"><path d="M12 2.6l2.7 6.4 6.9.6-5.2 4.5 1.6 6.7L12 17.4 5.99 20.8 7.6 14.1 2.4 9.6l6.9-.6z"/></svg>`;
  }

  function iconCartWhite() {
    return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><path d="M6 6h15l-1.5 9h-12z"/><path d="M6 6L5 3H2"/><circle cx="9" cy="20" r="1.4" fill="#fff"/><circle cx="18" cy="20" r="1.4" fill="#fff"/></svg>`;
  }

  function iconSearch() {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9aa0a6" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>`;
  }

  function iconInfo() {
    return `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 8h.01"/></svg>`;
  }

  function pickSellers(productId, count) {
    const start = hashSeed(String(productId)) % SELLER_NAMES.length;
    const rotated = SELLER_NAMES.slice(start).concat(SELLER_NAMES.slice(0, start));
    const extra = [];
    let n = 1;
    while (rotated.length + extra.length < count) {
      extra.push(`Independent Seller ${n}`);
      n += 1;
    }
    return rotated.concat(extra).slice(0, count).map(sellerProfile);
  }

  function listingCount(id) {
    const idn = Number(id) || hashSeed(String(id));
    return 24 + (idn % 17);
  }

  function isSingleCard(product) {
    if (product.isCard === true || product.isCard === "true") return true;
    if (product.isCard === false || product.isCard === "false") return false;
    const title = String(product.title || "");
    const blob = `${title} ${product.type || ""} ${product.handle || ""}`.toLowerCase();
    const hasNumber = /\d+\s*\/\s*\d+/.test(title) || /-[a-z]{2}\d{3}/i.test(title);
    const sealed = /sealed|booster|elite trainer|\betb\b|display|bundle|playmat|sleeves?|deck box|binder|\btin\b|blister/.test(blob);
    if (hasNumber) return true;
    if (sealed) return false;
    return /single/.test(blob);
  }

  function listingsFor(product) {
    const base = Number(product.price) || 0.99;
    if (isSingleCard(product)) {
      const seller = pickSellers(product.id, 1)[0];
      return [{
        cond: "Near Mint",
        printing: "Normal",
        seller,
        price: +base.toFixed(2),
        qty: 1,
      }];
    }
    const shown = Math.min(12, listingCount(product.id));
    const sellers = pickSellers(product.id, shown);
    return sellers.map((seller, i) => ({
      cond: CONDITIONS[i % CONDITIONS.length],
      printing: i % 4 === 1 ? "Holofoil" : i % 4 === 2 ? "Reverse Holofoil" : "Normal",
      seller,
      price: +(base * (1 + i * 0.045)).toFixed(2),
      qty: 2 + (hashSeed(String(product.id) + seller.name) % 7),
    }));
  }

  function offerLabel(r) {
    return [r.cond, r.printing === "Normal" ? "1st Edition" : r.printing].filter(Boolean).join(" ");
  }

  function sellerReviews(seller) {
    const n = 6 + (hashSeed(seller.name) % 8);
    return Array.from({ length: n }, (_, i) => {
      const h = hashSeed(seller.name + ":" + i);
      const d = new Date();
      d.setDate(d.getDate() - (2 + (h % 400)));
      return {
        stars: h % 17 === 0 ? 4 : 5,
        comment: COMMENTS[h % COMMENTS.length],
        date: d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }),
        buyer: `Buyer${1000 + (h % 9000)}`,
      };
    });
  }

  function sellerShopItems(seller, catalog) {
    if (!catalog.length) return [];
    const seed = hashSeed(seller.name);
    const take = Math.min(catalog.length, 48 + (seed % 36));
    const start = seed % catalog.length;
    const step = 1 + (seed % 5);
    const out = [];
    const seen = new Set();
    for (let i = 0; i < catalog.length * 2 && out.length < take; i++) {
      const p = catalog[(start + i * step) % catalog.length];
      if (seen.has(String(p.id))) continue;
      seen.add(String(p.id));
      out.push(p);
    }
    return out;
  }

  function parseSellerHash() {
    const raw = location.hash || "";
    const m = raw.match(/^#\/seller\/([^?]*)(\?(.*))?$/);
    if (!m) return null;
    let name = m[1] || "";
    try { name = decodeURIComponent(name.replace(/\+/g, " ")); } catch (_) { /* keep */ }
    const params = new URLSearchParams(m[3] || "");
    return { name, params };
  }

  function shopCard(p) {
    const img = p.image || "";
    return `<a class="shop-card" href="${escapeHtml(p.url)}">
      <div class="shop-card-img">${img ? `<img src="${escapeHtml(img)}" alt="${escapeHtml(p.title)}">` : ""}</div>
      <div>
        <h3>${escapeHtml(p.title)}</h3>
        <div class="shop-card-set">${escapeHtml(p.type || p.vendor || "")}</div>
      </div>
    </a>`;
  }

  function renderSellerPage(mount, seller, params, catalog) {
    const tab = params.get("tab") === "feedback" ? "feedback" : "shop";
    const q = (params.get("q") || "").trim();
    const line = params.get("line") || "";
    const sort = params.get("sort") || "best";
    const page = Math.max(1, Number(params.get("page") || 1));
    const per = 24;
    const inventory = sellerShopItems(seller, catalog);
    let items = inventory;
    const lines = [...new Set(inventory.map((p) => p.vendor).filter(Boolean))].sort();
    if (q) {
      const needle = q.toLowerCase();
      items = items.filter((p) => `${p.title} ${p.type} ${p.vendor}`.toLowerCase().includes(needle));
    }
    if (line) items = items.filter((p) => p.vendor === line);
    if (sort === "price-asc") items = [...items].sort((a, b) => (a.price || 0) - (b.price || 0));
    else if (sort === "price-desc") items = [...items].sort((a, b) => (b.price || 0) - (a.price || 0));
    else if (sort === "name") items = [...items].sort((a, b) => String(a.title).localeCompare(String(b.title)));
    const total = items.length;
    const pages = Math.max(1, Math.ceil(total / per));
    const cur = Math.min(page, pages);
    const slice = items.slice((cur - 1) * per, cur * per);
    const positive = seller.rating >= 99.6 ? "100%" : `${seller.rating.toFixed(1)}%`;
    const years = `${seller.years} year${seller.years === 1 ? "" : "s"} on TCGplayer`;
    const filtered = sessionStorage.getItem("tcg-seller-filter") === seller.name;
    const reviews = sellerReviews(seller);
    const shopHref = sellerHref(seller.name);
    const fbHref = sellerHref(seller.name, new URLSearchParams("tab=feedback"));

    mount.innerHTML = `
    <div class="page-width page seller-page" data-seller-page data-seller-name="${escapeHtml(seller.name)}">
      <div class="seller-head">
        <div>
          <h1 class="seller-name">${escapeHtml(seller.name)}${seller.certified ? `<span class="cert-star" title="Certified Seller">${iconCertStar()}</span>` : ""}</h1>
          <div class="seller-loc">${escapeHtml(seller.city)}</div>
          <div class="seller-stats">
            <span>${positive} positive rating</span>
            <span>${seller.sales.toLocaleString()} sales</span>
            <span>${escapeHtml(years)}</span>
          </div>
        </div>
        <div class="seller-head-act">
          <button class="btn-filter-seller${filtered ? " on" : ""}" type="button" data-filter-seller>
            ${iconCartWhite()} Filter to This Seller
          </button>
          <button class="what-this" type="button" data-what-filter>${iconInfo()} What does this do?</button>
        </div>
      </div>
      <nav class="seller-tabs">
        <a class="${tab === "shop" ? "active" : ""}" href="${shopHref}">Shop</a>
        <a class="${tab === "feedback" ? "active" : ""}" href="${fbHref}">Feedback</a>
      </nav>
      ${tab === "feedback" ? `
      <div class="fb-panel">
        <div class="fb-summary"><strong>${positive}</strong> positive rating · ${seller.reviews.toLocaleString()} ratings</div>
        <div class="fb-list">
          ${reviews.map((r) => `
            <article class="fb-item">
              <div class="fb-stars">${"★".repeat(r.stars)}${"☆".repeat(5 - r.stars)}</div>
              <p>${escapeHtml(r.comment)}</p>
              <div class="fb-meta">${escapeHtml(r.buyer)} · ${escapeHtml(r.date)}</div>
            </article>`).join("")}
        </div>
      </div>` : `
      <div class="shop-panel">
        <div class="shop-top">
          <h2>Shop ${escapeHtml(seller.name)}</h2>
          <form class="shop-search" data-seller-shop-form>
            ${iconSearch()}
            <input name="q" value="${escapeHtml(q)}" placeholder="Search all ${inventory.length.toLocaleString()} items..." autocomplete="off">
          </form>
        </div>
        <div class="shop-tools">
          <div class="shop-tools-left">
            <button class="filter-btn" type="button" data-seller-filters>All Filters</button>
            <select class="filter-btn" data-seller-filter="line">
              <option value="">Product Line</option>
              ${lines.map((g) => `<option value="${escapeHtml(g)}" ${line === g ? "selected" : ""}>${escapeHtml(g)}</option>`).join("")}
            </select>
          </div>
          <div class="sort-box shop-sort">
            <span>Sort By</span>
            <select data-seller-filter="sort">
              <option value="best" ${sort === "best" ? "selected" : ""}>Best Selling</option>
              <option value="price-asc" ${sort === "price-asc" ? "selected" : ""}>Price: Low to High</option>
              <option value="price-desc" ${sort === "price-desc" ? "selected" : ""}>Price: High to Low</option>
              <option value="name" ${sort === "name" ? "selected" : ""}>Name A-Z</option>
            </select>
          </div>
        </div>
        <div class="seller-filters" data-seller-filter-panel>
          <div>
            <h4>Condition</h4>
            ${CONDITIONS.map((c) => `<label><input type="checkbox" checked> ${c}</label>`).join("")}
          </div>
          <div>
            <h4>Printing</h4>
            <label><input type="checkbox" checked> Normal</label>
            <label><input type="checkbox" checked> Holofoil</label>
          </div>
        </div>
        <div class="shop-grid">
          ${slice.map(shopCard).join("") || `<div class="empty">No items match this search.</div>`}
        </div>
        ${pages > 1 ? `<div class="pager">
          <button type="button" data-seller-page-num="${cur - 1}" ${cur <= 1 ? "disabled" : ""}>‹</button>
          <span>${cur} / ${pages}</span>
          <button type="button" data-seller-page-num="${cur + 1}" ${cur >= pages ? "disabled" : ""}>›</button>
        </div>` : ""}
      </div>`}
    </div>`;
    bindSellerPage(mount, seller);
  }

  function renderSellerDirectory(mount) {
    const extra = (cfg.vendors || []).filter(Boolean);
    const names = [...new Set(SELLER_NAMES.concat(extra))];
    mount.innerHTML = `
    <div class="page-width page seller-page">
      <h1 class="seller-name">Sellers</h1>
      <p class="seller-loc">Shop stores and read seller feedback.</p>
      <div class="seller-dir">
        ${names.map((name) => {
          const s = sellerProfile(name);
          const positive = s.rating >= 99.6 ? "100%" : `${s.rating.toFixed(1)}%`;
          return `<a class="seller-dir-card" href="${sellerHref(s.name)}">
            <div class="seller-dir-name">${escapeHtml(s.name)}${s.certified ? `<span class="cert-star">${iconCertStar()}</span>` : ""}</div>
            <div class="seller-loc">${escapeHtml(s.city)}</div>
            <div class="seller-stats"><span>${positive} positive</span><span>${s.sales.toLocaleString()} sales</span></div>
          </a>`;
        }).join("")}
      </div>
    </div>`;
  }

  function updateSellerParams(seller, mutate) {
    const current = parseSellerHash()?.params || new URLSearchParams();
    mutate(current);
    location.hash = `/seller/${encodeURIComponent(seller.name)}${current.toString() ? "?" + current.toString() : ""}`;
  }

  function bindSellerPage(rootEl, seller) {
    rootEl.querySelector("[data-seller-shop-form]")?.addEventListener("submit", (e) => {
      e.preventDefault();
      const q = e.target.q?.value || "";
      updateSellerParams(seller, (p) => {
        if (q.trim()) p.set("q", q.trim());
        else p.delete("q");
        p.delete("page");
      });
    });
    rootEl.querySelectorAll("[data-seller-filter]").forEach((el) => {
      el.addEventListener("change", () => {
        updateSellerParams(seller, (p) => {
          if (!el.value) p.delete(el.dataset.sellerFilter);
          else p.set(el.dataset.sellerFilter, el.value);
          p.delete("page");
        });
      });
    });
    rootEl.querySelector("[data-seller-filters]")?.addEventListener("click", () => {
      rootEl.querySelector("[data-seller-filter-panel]")?.classList.toggle("open");
    });
    rootEl.querySelectorAll("[data-seller-page-num]").forEach((el) => {
      el.addEventListener("click", () => {
        if (el.disabled) return;
        updateSellerParams(seller, (p) => p.set("page", el.dataset.sellerPageNum));
      });
    });
    rootEl.querySelector("[data-filter-seller]")?.addEventListener("click", () => {
      const on = sessionStorage.getItem("tcg-seller-filter") === seller.name;
      if (on) sessionStorage.removeItem("tcg-seller-filter");
      else sessionStorage.setItem("tcg-seller-filter", seller.name);
      rootEl.querySelector("[data-filter-seller]")?.classList.toggle("on", !on);
    });
    rootEl.querySelector("[data-what-filter]")?.addEventListener("click", () => {
      const modal = document.createElement("div");
      modal.className = "modal";
      modal.innerHTML = `<div class="modal-card">
        <h3>Filter to This Seller</h3>
        <p>This keeps search and product listings limited to this seller so you can shop their inventory without seeing other stores.</p>
        <div class="modal-actions"><button class="btn btn-blue" type="button" data-close>Got it</button></div>
      </div>`;
      modal.addEventListener("click", (e) => {
        if (e.target === modal || e.target.closest("[data-close]")) modal.remove();
      });
      document.body.appendChild(modal);
    });
  }

  async function catalog() {
    if (Array.isArray(cfg.catalog) && cfg.catalog.length) return cfg.catalog;
    if (window.__TCG_CATALOG) return window.__TCG_CATALOG;
    try {
      const res = await fetch("/collections/all/products.json?limit=250");
      const json = await res.json();
      window.__TCG_CATALOG = (json.products || []).map((p) => ({
        id: p.id,
        title: p.title,
        url: `/products/${p.handle}`,
        vendor: p.vendor,
        type: p.product_type,
        image: p.images?.[0]?.src || "",
        price: Number(p.variants?.[0]?.price || 0),
      }));
      return window.__TCG_CATALOG;
    } catch (_) {
      return [];
    }
  }

  async function bootSellerApp() {
    const mount = document.querySelector("[data-seller-app]");
    const hash = parseSellerHash();
    if (!mount && hash) {
      location.replace(`${root}?view=seller${location.hash}`);
      return;
    }
    if (!mount) return;
    const items = await catalog();
    const fixed = mount.dataset.sellerName;
    const route = hash || (fixed ? { name: fixed, params: new URLSearchParams() } : null);
    if (!route || !route.name) {
      renderSellerDirectory(mount);
      return;
    }
    renderSellerPage(mount, findSeller(route.name), route.params, items);
  }

  function renderProductSellers() {
    const box = document.querySelector("[data-seller-listings]");
    if (!box) return;
    const product = {
      id: box.dataset.productId,
      title: box.dataset.productTitle,
      type: box.dataset.productType,
      handle: box.dataset.productHandle,
      price: Number(box.dataset.price || 0) / 100,
      variantId: box.dataset.variantId,
      available: box.dataset.available !== "false",
      isCard: box.dataset.isCard,
    };
    const single = isSingleCard(product);
    const rows = listingsFor(product);
    const offer = rows[0];
    const others = single ? [] : rows.slice(1, 8);
    const buy = document.querySelector("[data-buy-seller]");
    if (buy && offer) {
      buy.innerHTML = `Sold by <a href="${sellerHref(offer.seller.name)}">${escapeHtml(offer.seller.name)}</a><div class="seller-fb">${escapeHtml(sellerFeedback(offer.seller))}</div>`;
    }
    const condEl = document.querySelector("[data-buy-cond]");
    if (condEl && offer && product.available) condEl.textContent = offerLabel(offer);
    const qtySel = document.querySelector("[data-pdp-qty]");
    const ofEl = document.querySelector("[data-buy-of]");
    if (qtySel && offer) {
      const n = Math.max(1, Number(offer.qty) || 1);
      qtySel.innerHTML = Array.from({ length: n }, (_, i) => `<option value="${i + 1}">${i + 1}</option>`).join("");
      if (ofEl) ofEl.textContent = `of ${n}`;
    }
    const pay4 = document.querySelector("[data-pay-in-4]");
    if (pay4 && offer) pay4.textContent = money(offer.price / 4);
    const meta = document.querySelector(".pdp-listing-meta b");
    if (meta) meta.textContent = `${rows.length} Listing${rows.length === 1 ? "" : "s"}`;
    const otherBox = document.querySelector(".other-box");
    const other = document.querySelector("[data-other-listings]");
    if (single) {
      if (otherBox) otherBox.hidden = true;
      if (other) other.hidden = true;
    } else {
      if (otherBox) otherBox.hidden = false;
      if (other) {
        other.hidden = false;
        const n = Math.max(others.length, 1);
        other.textContent = `View ${n} Other Listing${n === 1 ? "" : "s"}`;
      }
    }
    const stack = document.querySelector("[data-sold-stack]");
    if (stack) {
      stack.innerHTML = single ? "" : `<h3>Sold by ${rows.length} sellers</h3>
        ${others.map((r) => {
          const label = offerLabel(r);
          return `<div class="sold-card">
            <div class="buy-cond">${escapeHtml(label)}</div>
            <div class="buy-listing">
              <span class="sold-price">${money(r.price)}</span><span class="buy-currency">USD</span>
              <span class="buy-ship">Shipping: <a href="/">Included</a></span>
            </div>
            <div class="buy-seller">
              Sold by <a href="${sellerHref(r.seller.name)}">${escapeHtml(r.seller.name)}</a>
            </div>
            <div class="buy-actions">
              <select class="atc-qty" data-listing-qty>
                ${Array.from({ length: r.qty }, (_, i) => `<option value="${i + 1}">${i + 1}</option>`).join("")}
              </select>
              <span class="buy-of">of ${r.qty}</span>
              <button class="btn-atc" type="button" data-add-listing
                data-variant="${product.variantId}" data-cond="${escapeHtml(label)}"
                data-seller="${escapeHtml(r.seller.name)}">Add to Cart</button>
            </div>
          </div>`;
        }).join("")}`;
    }
    box.innerHTML = `
      <h3>All Listings · ${rows.length} seller${rows.length === 1 ? "" : "s"}</h3>
      ${rows.map((r) => {
        const label = offerLabel(r);
        return `<div class="listing">
          <div class="seller">
            <a href="${sellerHref(r.seller.name)}">${escapeHtml(r.seller.name)}</a>
            <div class="seller-fb">${escapeHtml(sellerFeedback(r.seller))}</div>
          </div>
          <div>${escapeHtml(label)}</div>
          <div>
            <strong>${money(r.price)}</strong>
            <div class="muted">+ ${money(SHIPPING)} Shipping</div>
          </div>
          <div class="listing-act">
            <select class="atc-qty" data-listing-qty>${Array.from({ length: r.qty }, (_, i) => `<option value="${i + 1}">${i + 1}</option>`).join("")}</select>
            <span class="buy-of">of ${r.qty}</span>
            <button class="btn-atc btn-atc-sm" type="button" data-add-listing
              data-variant="${product.variantId}" data-cond="${escapeHtml(label)}"
              data-seller="${escapeHtml(r.seller.name)}">Add to Cart</button>
          </div>
        </div>`;
      }).join("")}`;
  }

  async function addListing(btn) {
    const row = btn.closest(".listing, .sold-card");
    const qty = Number(row?.querySelector("[data-listing-qty]")?.value || 1);
    const id = btn.dataset.variant;
    const properties = { Seller: btn.dataset.seller, Condition: btn.dataset.cond };
    const label = btn.textContent;
    btn.disabled = true;
    btn.classList.add("is-loading");
    btn.textContent = "Adding...";
    try {
      if (window.themeCart?.addToCart) {
        await window.themeCart.addToCart(id, qty, properties);
        return;
      }
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, quantity: qty, properties }),
      });
      const data = await fetch("/cart.js").then((r) => r.json());
      window.themeCart?.setCount?.(data.item_count);
      window.themeCart?.renderDrawer?.(data);
      window.themeCart?.openDrawer?.();
    } finally {
      btn.disabled = false;
      btn.classList.remove("is-loading");
      btn.textContent = label;
    }
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-add-listing]");
    if (!btn) return;
    e.preventDefault();
    addListing(btn).catch(() => alert("Could not add to cart."));
  });

  window.addEventListener("hashchange", () => {
    if (document.querySelector("[data-seller-app]")) bootSellerApp();
  });

  window.TCGSeller = { sellerHref, findSeller, sellerProfile };

  bootSellerApp();
  renderProductSellers();
})();
